var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1751_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 13.2168V11.8835C10.667 11.1762 10.386 10.4979 9.88594 9.99785C9.38585 9.49775 8.70757 9.2168 8.00033 9.2168H3.33366C2.62641 9.2168 1.94814 9.49775 1.44804 9.99785C0.947944 10.4979 0.666992 11.1762 0.666992 11.8835V13.2168",
    stroke: "var(--primary-color-text)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 6.55013C7.13943 6.55013 8.33333 5.35622 8.33333 3.88346C8.33333 2.4107 7.13943 1.2168 5.66667 1.2168C4.19391 1.2168 3 2.4107 3 3.88346C3 5.35622 4.19391 6.55013 5.66667 6.55013Z",
    stroke: "var(--primary-color-text)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4.55078V8.55078",
    stroke: "var(--primary-color-text)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 6.55078H11.333",
    stroke: "var(--primary-color-text)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1751_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserplus);
export default __webpack_public_path__ + "static/media/userplus.5016817777002190f00e849960c723ca.svg";
export { ForwardRef as ReactComponent };